import {
  DETAIL_GET_CONTARCT_SUCCESS,
  DETAIL_GET_CONTRACT_ERROR,
  DETAIL_GET_CONTRACT_START,
  ADMIN_HISTORY_GET_CONTARCT_SUCCESS,
  ADMIN_HISTORY_GET_CONTARCT_ERROR,
  ADMIN_HISTORY_GET_CONTARCT_START,
} from "../Constants/ContractDetailConstant";
const initialState = {
  loading: false,
  data: [],
  preOnboardData: [],
  activeContract: [],
  cinstrctHistoryDetail: [],
};

export default function ContractDetailReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case DETAIL_GET_CONTRACT_START:
      return {
        ...state,
        loading: true,
      };
    case DETAIL_GET_CONTARCT_SUCCESS:
      return {
        ...state,
        data: action.payload?.contract,
        preOnboardData: action.payload?.preOnBoardingRentalOp,
        activeContract: action.payload,
        loading: false,
      };
    case DETAIL_GET_CONTRACT_ERROR:
      return {
        ...state,
        loading: false,
        message: action?.error?.message,
      };
    case ADMIN_HISTORY_GET_CONTARCT_START:
      return {
        ...state,
        loading: true,
      };
    case ADMIN_HISTORY_GET_CONTARCT_SUCCESS:
      return {
        ...state,
        cinstrctHistoryDetail: action.payload,
        loading: false,
      };
    case ADMIN_HISTORY_GET_CONTARCT_ERROR:
      return {
        ...state,
        loading: false,
        message: action?.error?.message,
      };
    default:
      return state;
  }
}
